import { forwardRef, type Ref, type SVGProps } from "react";

function SvgChevronUp(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m2.667 10 3.919-3.92a2 2 0 0 1 2.828 0l3.92 3.92"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChevronUp);
export default ForwardRef;
